import { render, staticRenderFns } from "./header-sidebar.vue?vue&type=template&id=0b105fe5&scoped=true&"
import script from "./header-sidebar.vue?vue&type=script&lang=js&"
export * from "./header-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./header-sidebar.vue?vue&type=style&index=0&id=0b105fe5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b105fe5",
  null
  
)

export default component.exports